// extracted by mini-css-extract-plugin
export default {"projectOverview":"ProjectOverview_projectOverview__TwUnc"};